var file_upload_viewer_default = {
  "fontElementMap": "_4N8Gi",
  "file_upload_container": "_7wUXp",
  "file_upload_error_container": "ut9sG",
  "file_upload_link": "UVf2h",
  "width_three": "zNjQm",
  "file_upload_text_container": "eIFCW",
  "width_two": "zzFcR",
  "file_upload_state": "SfGfK",
  "mobile_status_icon": "CJUdN",
  "file_upload_name_container": "H0GTf",
  "file_upload_name": "tUPwC",
  "file_upload_extension": "-WxGE",
  "width_one": "SzaX3",
  "file_upload_type_icon": "E5D6y",
  "file_loader_icon": "H0sXL",
  "spin": "LG0tQ",
  "file_upload_type": "_32mGz",
  "file_upload_text_error": "TvOp1",
  "file_upload_icon_frame": "YFiMO",
  "file_upload_icon_background": "eRwAT"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
